import { ReactNode } from "react";

import styles from "./OnboardingLayout.module.scss";
import { Button, StepProps, Steps, Typography } from "antd";
import Logo from "components/Logo";
import { useLocation, useNavigate } from "react-router-dom";
import OnboardingLoader, { T_OnboardingLoaderProps } from "pages/Onboarding/components/OnboardingLoader";
import { ONBOARDING_ROUTES } from "utils/routes";

import { TbArrowBackUp } from "react-icons/tb";
import { ApiService } from "api/api.service";
import { ApplicationSchemaDto } from "types/application.types";

const getSteps = (application: ApplicationSchemaDto): (StepProps & { link: string; childSteps?: number })[] => {
  let stepsList: ReturnType<typeof getSteps> = [
    {
      link: "upload-loan-docs",
      childSteps: 3,
      title: "Upload Loan Documents",
      description: "Upload your all loan related docs",
    },
  ];
  if (!application?.plaid_config || application?.plaid_config?.connected === false) {
    stepsList.push({
      link: "upload-bank-docs",
      childSteps: 2,
      title: "Upload Bank Statements",
      description: "Last 3 years of bank statements",
    });
  }
  const moreSteps: ReturnType<typeof getSteps> = [
    {
      link: "choose-plan",
      title: "Select Relief Plan",
      description: "Choosing your optimal strategy",
    },
    {
      link: "personal-info",
      title: "Basic Information",
      description: "Your Name, Business Name etc.",
    },
    {
      link: "sign-contract",
      title: "Sign Contracts",
      description: "Review and sign the paperwork",
    },
    {
      link: "finish-onboarding",
      title: "Finish Onboarding",
      description: "Start resolving by paying fees",
    },
  ];

  stepsList = stepsList.concat(moreSteps);

  return stepsList.map((el) => {
    return {
      ...el,
      title: (
        <Typography.Title className="!mb-1 !text-base" level={5}>
          {el.title}
        </Typography.Title>
      ),
      description: (
        <Typography.Text className="!text-sm" type="secondary">
          {el.description}
        </Typography.Text>
      ),
    };
  });
};

function getNameInitials(name: string) {
  const split = name?.split(" ");
  return split?.[0]?.[0]?.toUpperCase() + (split?.length > 1 ? split?.[1]?.[0]?.toUpperCase() : "");
}

function OnboardingLayout({
  children,
  stepsShow = true,
  loader,
}: {
  children: ReactNode;
  stepsShow?: boolean;
  loader?: T_OnboardingLoaderProps & {
    isLoading?: boolean;
  };
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const application = ApiService.onboarding.useGetApplicationById("abc");
  const hasAdminTokens = !!localStorage.getItem("initialAccessToken") && !!localStorage.getItem("initialRefreshToken");
  const loginAsOther = ApiService.user.useLoginAsOther();

  return (
    <div className="bg-no-repeat bg-cover min-h-screen bg-transparent" style={{ backgroundImage: "url(/bg.png)" }}>
      {/* <div className="sticky top-0 z-50 bg-white shadow-md flex justify-between h-[84px] p-5 items-center w-full">
        <Logo />
        <div className="flex gap-3">
          {hasAdminTokens && (
            <Button
              type="primary"
              icon={<TbArrowBackUp size={16} />}
              onClick={() => {
                const initialAccess = localStorage.getItem("initialAccessToken");
                const initialRefresh = localStorage.getItem("initialRefreshToken");

                if (initialAccess && initialRefresh) {
                  localStorage.setItem("accessToken", initialAccess);
                  localStorage.setItem("refreshToken", initialRefresh);

                  localStorage.removeItem("initialAccessToken");
                  localStorage.removeItem("initialRefreshToken");

                  window.location.reload();
                }
              }}
            >
              Switch Back
            </Button>
          )}

          <Button onClick={logout} icon={<TbLogout />}>
            Logout
          </Button>
          <Button href={HOTPROSPECTOR_LINK} target="_blank">
            Get Help?
          </Button>
          {location?.pathname !== ONBOARDING_ROUTES.Status ? (
            <Button
              type="primary"
              onClick={() => {
                navigate(ONBOARDING_ROUTES.Status);
              }}
            >
              Start Over
            </Button>
          ) : null}
          <Popover
            trigger={["click"]}
            placement="bottomRight"
            arrow={false}
            title={userProfile?.data?.result?.name}
            content={
              <div className="flex flex-col gap-3">
                <Typography.Paragraph className="!m-0 !text-sm" type="secondary">
                  {userProfile?.data?.result?.email}
                </Typography.Paragraph>

                {userProfile?.data?.result?.email === storedTokens.registeredEmail.getToken() &&
                  (() => {
                    const recentUsersRaw = sessionStorage.getItem("currentUsers");
                    const recentUsers = recentUsersRaw ? JSON.parse(recentUsersRaw) : [];

                    if (!Array.isArray(recentUsers) || recentUsers.length === 0) {
                      return null;
                    }

                    return (
                      <div className="mt-2">
                        <div className="text-xs font-semibold text-gray-600 mb-1">Recent Sessions</div>

                        <div className="flex flex-col gap-2 max-h-48 overflow-y-auto pr-1">
                          {recentUsers.map((u: any, i: number) => (
                            <div
                              key={i}
                              className="flex justify-between items-center p-1 rounded hover:bg-gray-50 cursor-pointer"
                              onClick={() => {
                                loginAsOther.mutate(
                                  { email: u.email },
                                  {
                                    onSuccess: () => {
                                      message.success(`Succesfully logged in as ${u.name}!`);
                                    },
                                  },
                                );
                              }}
                            >
                              <div>
                                <div className="font-medium text-sm">{u.name}</div>
                                <div className="text-xs text-gray-500">{u.email}</div>
                              </div>

                              <Tooltip title="Switch to this user">
                                <Button type="text" size="small" icon={<TbSwitch size={14} />} />
                              </Tooltip>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })()}
              </div>
            }
          >
            <Avatar className="!bg-purple-200 !text-purple-700 cursor-pointer">
              {userProfile?.data?.result?.name ? getNameInitials(userProfile?.data?.result?.name) : loaderSm.primary}
            </Avatar>
          </Popover>
        </div>
      </div> */}
      {stepsShow && (
        <div
          className={`sticky top-[84px] h-[84px] z-50 bg-gray-50 border-t border-solid border-x-transparent border-b-transparent border-t-gray-300 shadow-md px-5 py-3 overflow-x-auto scrollbar-hidden ${styles.steps}`}
        >
          {application?.data?.result ? <StepsList application={application?.data?.result} /> : null}
        </div>
      )}
      {loader && loader.isLoading ? <OnboardingLoader {...loader} /> : children}
    </div>
  );
}

function StepsList({ application }: { application: ApplicationSchemaDto }) {
  const stepsList = getSteps(application);
  const currStep = stepsList.findIndex((el) => {
    return location.pathname.includes(el.link);
  });
  const parts = location?.pathname?.split("/").filter((el) => el.length > 0);

  const childStep = parseInt(parts[parts.length - 1]);

  return (
    <Steps
      items={stepsList.map((el) => ({ title: el.title, description: el.description }))}
      current={currStep}
      percent={stepsList[currStep].childSteps ? ((childStep - 1) / stepsList[currStep].childSteps) * 100 : undefined}
      responsive={false}
    />
  );
}

export default OnboardingLayout;
